<template>
  <div class="estimateCard">
    <h3 class="title title_order">基础信息</h3>
    <a-row :gutter="24">
      <a-col :span="8" v-for="el in baseFeild" :key="el.feild">
        <p class="p_text">
          {{el.name}}: {{infor[el.feild] || '-'}}
        </p>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import {baseFeild} from '../../EstimateConfig/estimateConfig'
export default {
  props: ['details'],
  data(){
    return{
      baseFeild,
      infor: { },
    }
  },
  watch:{
    details:{
      handler(data){
        let {prediction}=data
        this.infor={...prediction}
      },
      deep:true
    }
  },
}
</script>